import { FormattedMessage, useIntl } from 'react-intl';
import {
  Box,
  Heading,
  Image,
  Link,
  Tag,
  TagLeftIcon,
  TagLabel,
  Text,
} from '@chakra-ui/react';
import { CheckIcon, ExternalLinkIcon } from '@chakra-ui/icons';

import { formatShopifyImageURL } from 'src/utils/formatShopifyImageURL';
import WithoutImageDefault from 'src/img/semFoto.png';

import { PRODUCT_STATUS } from '../../../../const';
import messages from './messages';

export const Info = ({ product }) => {
  const intl = useIntl();

  if (!product) return null;

  const showInventaShopLinkIcon =
    product.status === PRODUCT_STATUS.ACTIVE && product.inventaShopProductURL;

  return (
    <>
      {showInventaShopLinkIcon ? (
        <Link href={product.inventaShopProductURL} isExternal>
          <Box display="flex" alignItems="center">
            <Heading>{product.name}</Heading>
            <ExternalLinkIcon mx={2} boxSize={6} />
          </Box>
        </Link>
      ) : (
        <Heading>{product.name}</Heading>
      )}
      <Image
        src={
          product.image
            ? formatShopifyImageURL(product.image.src, 240)
            : WithoutImageDefault
        }
        alt={
          product.image
            ? product.name
            : intl.formatMessage(messages.withoutProductImageAlt)
        }
      />
      <Box my={3}>
        <Text as="b" fontSize="lg">
          <FormattedMessage {...messages.skuLabel} />
        </Text>
        <Text>{product.sku}</Text>
      </Box>
      {product.isDeliveredNationalWide && (
        <Tag size="lg" colorScheme="gray">
          <TagLeftIcon boxSize="12px" as={CheckIcon} />
          <TagLabel>
            <FormattedMessage {...messages.deliveryNationalWideTag} />
          </TagLabel>
        </Tag>
      )}
    </>
  );
};
